import { List, Record } from 'immutable'

export const UsersRecord = Record({
  usersList: List(),
  mentionUsers: List(),
})

export class Users extends UsersRecord {}
